import React, { PropsWithChildren } from 'react';
import { scroller as reactScroller, Link as ReactLink } from 'react-scroll';
import { Scroller } from 'react-scroll/modules/mixins/scroller';
import { ReactScrollLinkProps } from 'react-scroll/modules/components/Link';
import domIds from './domIds';

const scrollTo: Scroller['scrollTo'] = (to: string, props: any) => {
  return reactScroller.scrollTo(to, { ...props, containerId: domIds.getMainContentId() });
};

export const scroller = { ...reactScroller, scrollTo };

export const Link = (props: PropsWithChildren<ReactScrollLinkProps>) => (
  <ReactLink {...({ ...props, containerId: domIds.getMainContentId() } as ReactScrollLinkProps)} />
);
